// 获取访客列表
import { configFetch as fetch } from '@laigu/utils';

// 获取排队列表
export const getQueueApi = () => {
  return fetch({
    url: '/agent/queue',
    method: 'get'
  });
};

// 接入排队访客
export const inviteQueueApi = params => {
  const { trackId } = params;

  return fetch({
    url: '/conversation/new',
    method: 'post',
    data: {
      track_id: trackId
    }
  });
};
